import React from 'react';
import { View, ScrollView, Appearance } from 'react-native';
import { router, useLocalSearchParams } from 'expo-router';
import axios from 'axios';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { TextInput, Button } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";
import { MainContext } from '../../../contexts/MainContext';
import Spacer from '../../../components/Spacer/Spacer';

export default function Page(){
  const myContext = React.useContext(MainContext);
  const { id } = useLocalSearchParams();
  const colorScheme = Appearance.getColorScheme();
  const [pageLoading, setPageLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [hour, setHour] = React.useState('');
  const [minute, setMinute] = React.useState('');
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  React.useEffect(() => {
    firstData();
  }, [])

  const firstData = () => {
    setPageLoading(true);
    axios.all([
      axios.put(`/panel/propertyVisit/${id}`),
    ])
      .then(axios.spread((response) => {
        if(response.data.status === true) {
          setData(response.data.data);

          if(response.data.data.dateTimes) {
            let times = response.data.data.dateTimes;
            const timeArray = times[0]?.time.split(":");
            setHour(timeArray[0]);
            setMinute(timeArray[1]);
            reset();
          }
        } else {
          myContext.activateSnackbar(true, response.data.message);
          router.push(-1);
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setPageLoading(false));
  }

  const formSubmit = (data) => {
    setSubmitLoading(true);
    Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});
    axios.all([
      axios.post(`/panel/propertyVisit/${id}`, data),
    ])
      .then(axios.spread((response) => {
        if(response.data.status === true) {
          myContext.activateSnackbar(true, 'درخواست شما با موفقیت ویرایش شد'); 
          router.push('/myVisitReport');
        } else {
          myContext.activateSnackbar(true, response.data.message);
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setSubmitLoading(false));
  }

  if(pageLoading) {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: 16, paddingHorizontal: 18 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
        </View>
        <Spacer height={16} />
        <Skeleton colorMode={colorScheme} width={'100%'} height={60} />
      </MotiView>
    );
  } else {
    return (
      <View style={{ flex: 1, justifyContent: 'space-between', backgroundColor: '#fcfcfd' }}>
        <ScrollView contentContainerStyle={{ paddingHorizontal: 18, paddingVertical: 16, backgroundColor: '#fcfcfd' }}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              label="کد آگهی"
              placeholder="کد آگهی مورد نظر را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.post_ids}
              onBlur={onBlur}
              onChangeText={onChange}
              defaultValue={value}
              maxLength={4}
              keyboardType='number-pad'
            />
          )}
          name="post_ids"
          defaultValue={data.postData?.postId+''}
        />
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              label="کد مشتری"
              placeholder="کد مشتری مورد نظر را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.crmId}
              onBlur={onBlur}
              onChangeText={onChange}
              maxLength={4}
              defaultValue={value}
              keyboardType='number-pad'
            />
            )}
          name="crmId"
          defaultValue={data.crmData?.crmId+''}
        />
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                label="دقیقه"
                placeholder=""
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ width: '49%', marginBottom: 24, fontSize: 14, textAlign: 'left' }}
                error={errors.minute}
                onBlur={onBlur}
                onChangeText={onChange}
                defaultValue={value}
                keyboardType='number-pad'
                maxLength={2}
              />
            )}
            name="minute"
            defaultValue={minute}
          />
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                label="ساعت"
                placeholder=""
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ width: '49%', marginBottom: 24, fontSize: 14, textAlign: 'left' }}
                error={errors.hour}
                onBlur={onBlur}
                onChangeText={onChange}
                defaultValue={value}
                keyboardType='number-pad'
                maxLength={2}
              />
            )}
            name="hour"
            defaultValue={hour}
          />
        </View>
        <Controller
          control={control}
          rules={{
            required: true,
           }}
           render={({ field: { onChange, onBlur, value } }) => (
             <TextInput
              label="توضیحات"
              placeholder="درصورت وجود توضیحات خود را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              multiline
              numberOfLines={4}
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.des}
              onBlur={onBlur}
              onChangeText={onChange}
              defaultValue={value}
            />
          )}
          name="des"
          defaultValue={data.des}
        />
        </ScrollView>
        <View style ={{ paddingHorizontal: 18, paddingBottom: 16 }}>
          <Button loading={submitLoading} disabled={submitLoading} labelStyle={{ fontSize: 16 }} style={{ width: '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(formSubmit)}>ویرایش گزارش</Button>
        </View>
      </View>
    );
  }
};